/**
 * DockAskSelection — the dock header's "Ask about selection" button.
 */
import React from 'react';

import { useActiveContext, composeSelectionPrompt } from '@shared/active-context';
import { Icons } from '@shared/components/ui';

import { FRAME_BTN } from './chatDockConstants';
import { useChatHandoffStore } from './useChatHandoff';

/** A frame button with a label: the shared frame class plus room for text. */
const BTN = `${FRAME_BTN} flex items-center gap-1 text-xs`;

/**
 * "Ask about selection": parks the retained selection, quoted, in the dock
 * composer. Rendered only while the context object holds a selection for the
 * focused tab; the dock is already open when its header is visible, so no
 * expand is needed. The prompt lands in the composer, never sent — the
 * question is the user's to finish. The visible text is the accessible name.
 */
export function DockAskSelection(): React.ReactElement | null {
  const { selection } = useActiveContext();
  const request = useChatHandoffStore(s => s.request);
  if (!selection) return null;
  return (
    <button
      type="button"
      onClick={() => request(composeSelectionPrompt(selection))}
      className={BTN}
    >
      <Icons.Quote size="sm" color="inherit" />
      <span>Ask about selection</span>
    </button>
  );
}
